import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import AppMedia from "../../../theme/utils/AppMedia";
import PageUtils from "../Page.utils";
import PageHeadingStyles from "./PageHeading.styles";
import {
  DefaultPageHeadingProps,
  IPageHeadingProps,
} from "./PageHeading.types";

const { Media } = AppMedia;

const PAGE_HEADING: React.FC<IPageHeadingProps> = ({ title }) => {
  const sendDataToGTM = useGTMDispatch();
  return (
    <PageHeadingStyles.PageHeading
      className="page-heading"
      data-testid="page-heading"
    >
      <span>{title}</span>

      <PageHeadingStyles.HowToVideoLinkButton
        className="howto-link-button"
        data-testid="howto-link-button"
        href="https://vimeo.com/716136265/b83b8335c9"
        target="_blank"
        onClick={
          /* istanbul ignore next */ () => {
            sendDataToGTM({
              event: "eventTracking",
              category: "Construction",
              action: "Click - HowtoVideoLink",
              label: `CE logo - ${PageUtils.getGTMPageLabel(false)}`,
            });
          }
        }
      >
        <Media greaterThanOrEqual="tablet">
          How to use your dashboard{" "}
          <FontAwesomeIcon
            icon={faExternalLinkAlt}
            data-testid="phase-list-icon"
          />
        </Media>
        <Media lessThan="tablet">
          <FontAwesomeIcon
            icon={faExternalLinkAlt}
            data-testid="phase-list-icon"
          />
        </Media>
      </PageHeadingStyles.HowToVideoLinkButton>
    </PageHeadingStyles.PageHeading>
  );
};

PAGE_HEADING.defaultProps = DefaultPageHeadingProps;

export default PAGE_HEADING;
